define(['jquery',
        '@microsoft/teams-js',
        'core/urls',
        'components/selectize'],
    function($, msteams, urls, selectize_util) {
        let nps_check = $('input[name="nps"]');
        let csat_check = $('input[name="csat"]');
        let csat_group = $('#csat-group');
        let csat_group_filters = $('#csat-group-filters');
        let nps_group = $('#nps-group');
        let nps_group_filters = $('#nps-group-filters');
        let csatComment = $('input[name="csat_filter_comments"]');
        let csatMaketingPermissions = $('input[name="csat_filter_mp"]');
        let npsComment = $('input[name="nps_filter_comments"]');
        let npsMaketingPermissions = $('input[name="nps_filter_mp"]');

        function updateForm() {
            let csatChecked = csat_check.prop('checked');
            let npsChecked = nps_check.prop('checked');
            
            if(!csatChecked && !npsChecked) {
                msteams.pages.config.setValidityState(false);
            } else {
                msteams.pages.config.setValidityState(true);
            }

            if(!csatChecked) {
                csat_group_filters.addClass("hide");
                csat_group.addClass("hide");
            } else {
                csat_group_filters.removeClass("hide");
                csat_group.removeClass("hide");
            }

            if(!npsChecked) {
                nps_group_filters.addClass("hide");
                nps_group.addClass("hide");
            } else {
                nps_group_filters.removeClass("hide");
                nps_group.removeClass("hide");
            }

            csat_group.prop("disabled", !csat_check.prop('checked'));
            nps_group.prop("disabled", !nps_check.prop('checked'));
        }

        let renderCheck = setInterval(() => {
            let selectizedElement = document.querySelector(".selectize-control");
            if (selectizedElement) {
                document.querySelectorAll(".group-wrapper.hide").forEach(el => {
                    el.classList.remove("hide");
                })
                clearInterval(renderCheck);
            }
        }, 100);

        return {
            init: function() {
                msteams.app.initialize().then(()=>{
                    window.Sentry.captureMessage(
                                    'Have been initialized',
                                    'info'
                                );
                    msteams.pages.config.registerOnSaveHandler(function(saveEvent){

                        window.Sentry.captureMessage(
                                    'Save button have been pressed',
                                    'info'
                                );
                        msteams.pages.getConfig().then((settings) => {

                            window.Sentry.withScope((scope) => {
                                scope.setExtra("config", JSON.stringify(settings));
                                window.Sentry.captureMessage(
                                    'In getConfig()',
                                    'info'
                                );
                            });
                            if(settings.entityId && settings.entityId.length){
                                let data = $('#create-config').serialize();
                                    $.post('', data).done(function (response) {
                                        saveEvent.notifySuccess();
                                    }).fail(function (xhr) {
                                        document.write(xhr.responseText);
                                        saveEvent.notifyFailure();
                                    });
                            } else {
                                msteams.app.getContext().then((context) => {
                                    window.Sentry.withScope((scope) => {
                                        scope.setExtra("context", context);
                                        window.Sentry.captureMessage(
                                            'In getContext()',
                                            'info'
                                        );
                                    });

                                    $('#create-config input[name="config"]').val(encodeURIComponent(JSON.stringify(settings)));
                                    $('#create-config input[name="identifier"]').val(settings.userObjectId);
                                    let data = $('#create-config').serialize();
                                    data += ("&name=" + context.channel.displayName);
                                    $.post('', data).done(function (response) {
                                        msteams.pages.config.setConfig({
                                            entityId: response.id,
                                            contentUrl: "https://" + window.location.hostname + urls['integration:update-channel-settings'](response.id),
                                            configName: "Channel " + context.channel.displayName,
                                        }).then(()=>{
                                            saveEvent.notifySuccess();
                                        });
                                    }).fail(function (xhr) {
                                        document.write(xhr.responseText);
                                        saveEvent.notifyFailure();
                                    });
                                });
                            }
                        });
                    });
                    msteams.pages.config.registerOnRemoveHandler(function(removeEvent){
                        msteams.pages.getConfig().then((settings) => {
                            $.post(urls['integration:revoke-channel'](settings.entityId)).done(function (response) {
                                removeEvent.notifySuccess();
                            }).fail(function (xhr) {
                                document.write(xhr.responseText);
                                removeEvent.notifyFailure();
                            });
                        });
                    });
                    updateForm();
                });

                $('input[name="nps"],input[name="csat"]').on('change', function (e) {
                    updateForm();
                });

                if(csatComment.prop('checked')){
                    csatMaketingPermissions.parent().removeClass("disabled");
                }

                if(npsComment.prop('checked')){
                    npsMaketingPermissions.parent().removeClass("disabled");
                }

                csatComment.on('change', function (e) {
                    if(csatComment.prop('checked')){
                        csatMaketingPermissions.parent().removeClass("disabled");
                    } else {
                        csatMaketingPermissions.parent().addClass("disabled");
                        csatMaketingPermissions.prop('checked', false)
                    }
                });

                npsComment.on('change', function (e) {
                    if(npsComment.prop('checked')){
                        npsMaketingPermissions.parent().removeClass("disabled");
                    } else {
                        npsMaketingPermissions.parent().addClass("disabled");
                        npsMaketingPermissions.prop('checked', false)
                    }
                });
            }
        };
    }
);
